import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ButtonBase
} from "@mui/material";
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { getDeviceImageUri } from "../helpers/untils";
import TimeTuroTripListContent from "./TimeTuroTripListContent";
import TripTimelineSpeedBox from "./TripTimelineSpeedBox";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '25px',
    height: '25px',
    filter: 'brightness(0) invert(1)',
  },
  avatar: {
    width: '25px',
    height: '25px',
    transform: 'scale(2)'
  }
}));
const TripDailyTimelineContent = (props) => {
  const { pageData = {}, apiLoading } = props;
  const { device, timelineList = [] } = pageData;
  const classes = useStyles();

  return (
    <Box p={2}>
      <Box>
        {
          (apiLoading) ? (
            <Typography variant="body1" align="center">
              Loading...
            </Typography>
          ) : (
            <>
              {/* Header */}
              <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                <Avatar>
                  <img className={device.image ? classes.avatar : classes.icon} src={getDeviceImageUri(device, true)} alt="" />
                </Avatar>
                <Stack direction="column" alignItems="flex-start" spacing={0}>
                  <Typography variant="h6" fontWeight={600}>
                    {device.name}
                  </Typography>
                  <Typography>
                    {device.vin}
                  </Typography>
                </Stack>
              </Stack>

              <TableContainer
                component={Paper}
                elevation={0}     // remove shadow
                sx={{ background: "transparent" }}
              >
                <Table
                  sx={{
                    "& td, & th": { padding: '8px 16px' },   // remove ALL borders
                  }}
                >
                  {/* <TableHead>
                        <TableRow>
                          <TableCell style={{ padding: '0px' }}></TableCell>
                          <TableCell style={{ padding: '0px', minWidth: '200px' }}></TableCell>
                          <TableCell style={{ padding: '0px' }}>Max Speed</TableCell>
                          <TableCell style={{ padding: '0px' }}>Turo Trip</TableCell>
                        </TableRow>
                      </TableHead> */}
                  <TableBody>
                    {
                      (timelineList.length > 0) ? (
                        <>
                          {timelineList.map((item, index) => (
                            <TableRow key={index}>
                              {/* Date */}
                              <TableCell>
                                <Stack direction={`row`} justifyContent={`flex-end`} alignItems={`center`}>
                                  <Typography>
                                    <b>{item.odometer}</b> {item.distanceUnitStr}
                                  </Typography>
                                </Stack>
                              </TableCell>

                              <TableCell sx={{ minWidth: '200px' }}>
                                <Typography>
                                  {`${item.startLocalTimeStr} to ${item.endLocalTimeStr}`}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                {/* max speed */}
                                <Stack direction={`row`} justifyContent={`flex-end`} alignItems={`center`}>
                                  <TripTimelineSpeedBox
                                    device={device}
                                    item={item}
                                  />
                                </Stack>
                              </TableCell>
                              <TableCell>
                                {/* Trip */}
                                <TimeTuroTripListContent
                                  timeTuroTripList={item.timeTuroTripList}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </>
                      ) : (
                        <>
                          <TableRow>
                            <TableCell colSpan={4} align="center">
                              <Typography>
                                No data available
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </>
                      )
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )
        }
      </Box>
    </Box>
  )
}

export default TripDailyTimelineContent;
